import React from 'react';
import CalculusOfSentiment from '../components/CalculusOfSentiment';

function CalculusOfSentimentPage() {
  return <CalculusOfSentiment />;
}

export default CalculusOfSentimentPage;
